import React, { useState } from 'react';
import { TKLineSelection } from './TKLineSelection';
import { TKLineProcess } from './TKLineProcess';
import { ProductionInstructions } from './ProductionInstructions';
interface TKLinesModuleProps {
  onBackToOverview?: () => void;
}
export function TKLinesModule({
  onBackToOverview
}: TKLinesModuleProps) {
  const [view, setView] = useState<'selection' | 'pre-instructions' | 'process' | 'post-instructions'>('selection');
  const [selectedLine, setSelectedLine] = useState<string>('');
  const [weighingMode, setWeighingMode] = useState<'line' | 'output'>('line');
  const [isBatchCompleted, setIsBatchCompleted] = useState(false);
  // Funktion, die aufgerufen wird, wenn ein Material zur Verwiegung ansteht
  const handleWeighingRequired = (materialId: string, orderId: string) => {
    // Hier könnten wir die Verwiegungsaufträge an einen globalen Zustand oder eine API senden
    console.log(`Material ${materialId} für Auftrag ${orderId} muss verwogen werden.`);
    // Kein Wechsel zur Verwiegungsmaske mehr, sondern nur Erfassung des Auftrags
  };
  const handleLineSelect = (lineId: string, selectedWeighingMode: 'line' | 'output') => {
    setSelectedLine(lineId);
    setWeighingMode(selectedWeighingMode);
    // Nach der Linienauswahl zuerst die "Vor der Produktion"-Hinweise anzeigen
    setView('pre-instructions');
  };
  const handlePreInstructionsComplete = () => {
    // Nach den Vor-Produktionshinweisen zum eigentlichen Prozess wechseln
    setView('process');
  };
  const handleBackToSelection = () => {
    setView('selection');
    setSelectedLine('');
    setIsBatchCompleted(false);
  };
  const handleBatchComplete = () => {
    // Wenn alle Materialien für den Auftrag verarbeitet wurden
    setIsBatchCompleted(true);
    setView('post-instructions');
  };
  const handlePostInstructionsComplete = () => {
    // Nach den Nach-Produktionshinweisen zurück zur Linienauswahl
    setView('selection');
    setSelectedLine('');
    setIsBatchCompleted(false);
  };
  if (view === 'selection') {
    return <TKLineSelection onBackToOverview={onBackToOverview} onLineSelect={handleLineSelect} data-id="element-2321" />;
  }
  if (view === 'pre-instructions') {
    return <ProductionInstructions lineId={selectedLine} type="pre" onComplete={handlePreInstructionsComplete} onBack={handleBackToSelection} data-id="element-2322" />;
  }
  if (view === 'process') {
    return <TKLineProcess lineId={selectedLine} weighingMode={weighingMode} onBack={handleBackToSelection} onWeighingRequired={handleWeighingRequired} onBatchComplete={handleBatchComplete} data-id="element-2323" />;
  }
  if (view === 'post-instructions') {
    return <ProductionInstructions lineId={selectedLine} type="post" onComplete={handlePostInstructionsComplete} onBack={handleBackToSelection} data-id="element-2324" />;
  }
  // Fallback
  return <TKLineSelection onBackToOverview={onBackToOverview} onLineSelect={handleLineSelect} data-id="element-2325" />;
}